// Configuração central do site Home Office Premium.
// IMPORTANTE: o endereço do catálogo privado é definido aqui, em um único lugar.
// Quando você trocar o endereço futuramente (domínio/subdomínio próprio),
// basta alterar CATALOG_URL abaixo e TODOS os botões do site passam a usar o novo link automaticamente.
//
// REGRA DE PRESERVAÇÃO: este site NUNCA autentica, cadastra ou consulta pedidos.
// Todo login, cadastro, recuperação de senha e histórico de pedidos continuam
// sendo feitos exclusivamente dentro do catálogo original, preservando as contas existentes.

export const CATALOG_URL =
  'https://readdy.cc/preview/fcf5ab1e-d06e-40e9-9e86-c6d9d8062e00/13441890/auth';

// Rota interna do site que apresenta o catálogo ao visitante (página pública e indexável).
export const CATALOG_ENTRY_PATH = '/catalogo';

export const WHATSAPP_NUMBER = '5581982030285';

export const SITE_URL = 'https://homeofficepremium.com';

// Mensagens contextuais oficiais do site (número 81 98203-0285).
export const WHATSAPP_MESSAGES = {
  cadeiras:
    'Olá! Gostaria de consultar cadeiras corporativas para minha empresa.',
  orgaoPublico:
    'Olá! Sou de um órgão público e gostaria de solicitar catálogo e cotação de mobiliário.',
  auditorio:
    'Olá! Preciso de opções de poltronas e cadeiras para auditório.',
  mesas:
    'Olá! Gostaria de consultar mesas e estações de trabalho.',
  projetos:
    'Olá! Gostaria de solicitar uma proposta de mobiliário para um ambiente profissional.',
  catalogo:
    'Olá! Gostaria de informações sobre o catálogo interativo da Home Office Premium.',
  urbano:
    'Olá! Gostaria de receber informações e orçamento de mobiliário para praças e espaços de convivência.',
  pracas:
    'Olá! Estou procurando cadeiras e mesas para uma praça de alimentação. Gostaria de conhecer as opções.',
  corporativo:
    'Olá! Gostaria de avaliar mobiliário para minha empresa.',
  acustica:
    'Olá! Gostaria de informações sobre divisórias, cabines e soluções acústicas corporativas.',
  divisoes:
    'Olá! Preciso de informações sobre divisórias corporativas para meu ambiente.',
} as const;

export type WhatsappContext = keyof typeof WHATSAPP_MESSAGES;

/** Monta o link do WhatsApp com a mensagem contextual já codificada. */
export function waLink(context: WhatsappContext): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGES[context])}`;
}

/** Monta um link do WhatsApp citando um produto específico (linha, modelo ou código). */
export function waProductLink(produto: string): string {
  const mensagem = `Olá! Gostaria de consultar disponibilidade e condições do produto: ${produto}.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(mensagem)}`;
}